import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { Block } from '../../abstract/Block.js';
export class Copyright extends Block {
  initCallback() {
    super.initCallback();
    this.subConfigValue('removeCopyright', /** @param {number} value */
    value => {
      this.toggleAttribute('hidden', !!value);
    });
  }
}
_defineProperty(Copyright, "template", /* HTML */"\n    <a\n      href=\"https://uploadcare.com/?utm_source=copyright&utm_medium=referral&utm_campaign=v4\"\n      target=\"_blank noopener\"\n      class=\"credits\"\n      >Powered by Uploadcare</a\n    >\n  ");